module.exports = __webpack_public_path__ + "static/img/more-8.0564d618.png";